import * as React from 'react';
import { connect } from 'react-redux';

import EmailField from '../components/EmailField';
import { StoreState } from 'src/types';
import { getLanguageReady } from 'src/reducers/i18n';

/**
 * Provides the validation that informs the EmailField component what to display
 * when an email address is being entered
 */
class EmailFieldContainer extends React.Component<
  EmailFieldContainerProps,
  EmailFieldContainerState
> {
  constructor(props: EmailFieldContainerProps) {
    super(props);

    const email = props.value || '';
    const validEmail = validateEmail(email);

    if (email) {
      this.props.onChange(email, validEmail);
    }

    this.state = {
      email,
      validEmail
    };
  }

  render() {
    return (
      <EmailField
        autoFocus={this.props.autoFocus}
        className={this.props.className}
        disabled={this.props.disabled}
        name={this.props.name}
        onChange={this.handleChange}
        showError={this.props.showError}
        showSsoLink={this.props.showSsoLink}
        ssoUrl={this.props.ssoUrl}
        validEmail={this.state.validEmail}
        value={this.state.email}
        languageReady={this.props.languageReady}
        trackLoginSSO={this.props.trackLoginSSO}
      />
    );
  }

  handleChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    // convert provided email to lowercase (LOGIN-144)
    const value = event.currentTarget.value.toLowerCase();
    const validEmail = validateEmail(value);
    this.props.onChange(value, validEmail);
    this.setState({
      email: value,
      validEmail: validEmail
    });
  };
}

export interface EmailFieldContainerProps {
  /** Optional class name to override styles */
  className?: string;

  /** Whether this field should be disabled */
  disabled?: boolean;

  /** Whether to focus this field as soon as it is rendered */
  autoFocus?: boolean;

  /** Input element name */
  name: string;

  /** Initial value of the email field */
  value?: string;

  /** Provides a hook to toggle displaying the error */
  showError?: boolean;

  /** Controls if we allow showing the single sign-on link */
  showSsoLink?: boolean;

  /** If provided, we'll send the user to the provided URL for auth */
  ssoUrl?: string;

  /** Flag to determine if translations are ready */
  languageReady: boolean;

  onChange(email: string, valid: boolean): void;

  /** Track snowplow event when a user clicks "Login with SSO" */
  trackLoginSSO?(): void;
}

export interface EmailFieldContainerState {
  /** Whether the current email is valid */
  validEmail: boolean;

  /** Current email value */
  email: string;
}

/**
 * Validates the provided email address
 * @param email
 */
export function validateEmail(email: string) {
  // Regex pattern provided by emailregex.com
  return (
    null !==
    email.match(
      // tslint:disable-next-line:max-line-length
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  );
}

const mapStateToProps = (
  state: StoreState,
  _ownProps: Pick<
    EmailFieldContainerProps,
    | 'className'
    | 'disabled'
    | 'autoFocus'
    | 'name'
    | 'value'
    | 'showError'
    | 'showSsoLink'
    | 'ssoUrl'
    | 'onChange'
  >
) => {
  return {
    ..._ownProps,
    languageReady: getLanguageReady(state)
  };
};

export default connect(mapStateToProps)(EmailFieldContainer);



// WEBPACK FOOTER //
// ./src/containers/EmailField.tsx